module.exports = __webpack_public_path__ + "static/about-2f72d79f3daca632d732296091c33751.jpg";